import React, { useState, useEffect } from "react";
import common_axios from "./../commonAxios";
import { Button, Flex, Select, Divider } from 'antd';
import "./StatsPage.css";

const StatsPage = () => {

    const [user, setUser] = useState();
    const [products, setProducts] = useState();
    const [postProductId, setProductId] = useState("");

    useEffect(() => {
        common_axios.get(`${process.env.REACT_APP_API_URL}/User/` + localStorage.getItem("userid") + `/ForStats`)
            .then(response => {
                setUser(response.data);
            })
            .catch(error => {
                console.error(error);
            });
        common_axios.get(`${process.env.REACT_APP_API_URL}/Product/forSelect`)
            .then(response => {
                setProducts(response.data);
            })
            .catch(error => {
                console.error(error);
            });
    }, []);

    const potionsToGoLabel = () => {
        let potionsCrafted = user?.craftedPotions;

        if (potionsCrafted < 5) {
            return (5 - potionsCrafted) + " potions to craft, before you reach Level " + (user?.level + 1);
        }
        if (potionsCrafted < 10) {
            return (10 - potionsCrafted) + " potions to craft, before you reach Level " + (user?.level + 1);
        }
        if (potionsCrafted < 20) {
            return (20 - potionsCrafted) + " potions to craft, before you reach Level " + (user?.level + 1);
        }
        if (potionsCrafted < 35) {
            return (35 - potionsCrafted) + " potions to craft, before you reach Level " + (user?.level + 1);
        }
        if (potionsCrafted < 50) {
            return (50 - potionsCrafted) + " potions to craft, before you reach Level " + (user?.level + 1);
        }
    }

    const levelname = (level) => {
        switch (level) {
            case 0:
                return "Anfänger";
            case 1:
                return "Auszubildender";
            case 2:
                return "Junior";
            case 3:
                return "Senior";
            case 4:
                return "Experte";
            case 5:
                return "Meister";
        }
    }

    const buttonActiveClassName = (buttonLevel) => {
        return user?.feats[-1 + buttonLevel] === 0 && user?.level >= buttonLevel ? "selectable" : "unselectable";
    }

    const buttonFeatSelectedClassName = (buttonLevel, isLeftButton) => {
        if (isLeftButton) {
            return user?.feats[-1 + buttonLevel] === 2 ? "unselected" : "";
        }
        return user?.feats[-1 + buttonLevel] === 1 ? "unselected" : "";
    }

    const buttonActive = (buttonLevel) => {
        return user?.feats.at(-1 + buttonLevel) === 0 && user?.level >= buttonLevel;
    }

    const updateFeats = (buttonLevel, isLeftButton) => {
        let position = (-1 + buttonLevel);
        let value = isLeftButton ? 1 : 2;
        let newFeats = user?.feats;
        if (newFeats) {
            newFeats[position] = value;

            common_axios.put(`${process.env.REACT_APP_API_URL}/User/feats`, {
                id: localStorage.getItem("userid"),
                name: null,
                feats: newFeats,
                favPotionId: null
            }).then(() => {
                window.location.reload(false);
            }).catch(error => {
                console.error(error);
            });
        }
    }

    const updateFavPotion = (potionId) => {
        setProductId(potionId);
        common_axios.put(`${process.env.REACT_APP_API_URL}/User/favpotion`, {
            id: localStorage.getItem("userid"),
            name: null,
            feats: null,
            favPotionId: potionId
        })
            .catch(error => {
                console.error(error);
            });
    }

    return (
        <Flex className="mainWrapper">
            <div style={{ width: "30%", marginLeft: "5%" }}>
                <div className="leftWrapper">
                    <div className="title">
                        <label>STATISTIKEN</label>
                    </div>

                    <Divider variant="dashed" style={{ borderColor: "black" }} />
                    <div>
                        <label className="labelLevel">Level: {user?.level} ({levelname(user?.level)})<br /></label>
                        <label className="labelToGo">{potionsToGoLabel()}</label>
                    </div>

                    {user?.feats[4] === 2 &&
                        <>
                            <Divider variant="dashed" style={{ borderColor: "black" }} />
                            <Select
                                showSearch
                                placeholder="Select a potion"
                                optionFilterProp="label"
                                onChange={value => updateFavPotion(value)}
                                options={products}
                            />
                        </>
                    }
                    <Divider variant="dashed" style={{ borderColor: "black" }} />
                    <div className="subtitle">Gecraftete Potions: {user?.craftedPotions}</div>
                    <Divider variant="dashed" style={{ borderColor: "black" }} />
                    <div className="subtitle">Fehlgeschlagene Potions: {user?.failedPotions}</div>
                    <Divider variant="dashed" style={{ borderColor: "black" }} />
                    <div className="subtitle">Gelernte Rezepte: {user?.learnedRecipes}</div>
                    <Divider variant="dashed" style={{ borderColor: "black" }} />
                    <div className="subtitle">Gesamtanzahl Zutaten: {user?.totalIngredients}</div>
                    <Divider variant="dashed" style={{ borderColor: "black" }} />
                </div>
            </div>




            <div style={{ width: "40%", marginRight: "10%", marginLeft: "auto" }}>
                <div className="rightWrapper">
                    <div className="title">
                        <label>FEATS</label>
                    </div>

                    <Flex className="featWrapper" gap="large" vertical>
                        <Divider />

                        <div className="levelBox">
                            <div className="subLabelLevel">
                                <label>Level 1</label>
                            </div>
                            <Flex className="featSubWrapper" gap="large">
                                <Button disabled={!buttonActive(1)} className={["leftFeat", buttonActiveClassName(1), buttonFeatSelectedClassName(1, true)]} onClick={() => updateFeats(1, true)} >
                                    Extraktionsspezialist Natur
                                </Button>
                                <Button disabled={!buttonActive(1)} className={["rightFeat", buttonActiveClassName(1), buttonFeatSelectedClassName(1, false)]} onClick={() => updateFeats(1, false)}>
                                    Extraktionsspezialist Slight of Hand
                                </Button>
                            </Flex>
                        </div>

                        <Divider />

                        <div className="levelBox">
                            <div className="subLabelLevel">
                                <label>Level 2</label>
                            </div>
                            <Flex gap="large" className="featSubWrapper">
                                <Button disabled={!buttonActive(2)} className={["leftFeat", buttonActiveClassName(2), buttonFeatSelectedClassName(2, true)]} onClick={() => updateFeats(2, true)}>
                                    Verkäufer
                                </Button>
                                <Button disabled={!buttonActive(2)} className={["rightFeat", buttonActiveClassName(2), buttonFeatSelectedClassName(2, false)]} onClick={() => updateFeats(2, false)}>
                                    Heilende Aura
                                </Button>
                            </Flex>
                        </div>

                        <Divider />

                        <div className="levelBox">
                            <div className="subLabelLevel">
                                <label>Level 3</label>
                            </div>
                            <Flex gap="large" className="featSubWrapper">
                                <Button disabled={!buttonActive(3)} className={["leftFeat", buttonActiveClassName(3), buttonFeatSelectedClassName(3, true)]} onClick={() => updateFeats(3, true)}>
                                    Ruhige Hände
                                </Button>
                                <Button disabled={!buttonActive(3)} className={["rightFeat", buttonActiveClassName(3), buttonFeatSelectedClassName(3, false)]} onClick={() => updateFeats(3, false)}>
                                    Flinke Hände
                                </Button>
                            </Flex>
                        </div>

                        <Divider />

                        <div className="levelBox">
                            <div className="subLabelLevel">
                                <label>Level 4</label>
                            </div>
                            <Flex gap="large" className="featSubWrapper">
                                <Button disabled={!buttonActive(4)} className={["leftFeat", buttonActiveClassName(4), buttonFeatSelectedClassName(4, true)]} onClick={() => updateFeats(4, true)}>
                                    Gut belesen
                                </Button>
                                <Button disabled={!buttonActive(4)} className={["rightFeat", buttonActiveClassName(4), buttonFeatSelectedClassName(4, false)]} onClick={() => updateFeats(4, false)}>
                                    Nicht verloren
                                </Button>
                            </Flex>
                        </div>

                        <Divider />

                        <div className="levelBox">
                            <div className="subLabelLevel">
                                <label>Level 5</label>
                            </div>
                            <Flex gap="large" className="featSubWrapper">
                                <Button disabled={!buttonActive(5)} className={["leftFeat", buttonActiveClassName(5), buttonFeatSelectedClassName(5, true)]} onClick={() => updateFeats(5, true)}>
                                    Warum nicht beide
                                </Button>
                                <Button disabled={!buttonActive(5)} className={["rightFeat", buttonActiveClassName(5), buttonFeatSelectedClassName(5, false)]} onClick={() => updateFeats(5, false)}>
                                    Lieblingspotion
                                </Button>
                            </Flex>
                        </div>
                    </Flex>
                </div>
            </div>
        </Flex>
    );
};

export default StatsPage;